var _style, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:1.68;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{stroke:#000000;stroke-width:1.68;stroke-linecap:square;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:1.68;stroke-miterlimit:10;}\r\n\t.st4{opacity:0.6314;}\r\n\t.st5{opacity:0.9804;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:1.68;stroke-linecap:square;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.56,26.04H4.44c-0.97,0-1.75-0.8-1.75-1.79V3.45c0-0.99,0.79-1.79,1.75-1.79h4.59v1.68H4.44 c-0.04,0-0.07,0.05-0.07,0.11v20.81c0,0.06,0.04,0.11,0.07,0.11h17.12c0.04,0,0.08-0.05,0.08-0.11V3.45c0-0.06-0.04-0.11-0.08-0.11 h-4.71V1.66h4.71c0.97,0,1.75,0.8,1.75,1.79v20.81C23.32,25.24,22.53,26.04,21.56,26.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.32,1.68v1.79H9.68V1.68H16.32 M16.5,0h-7C8.67,0,8,0.67,8,1.5v2.15c0,0.83,0.67,1.5,1.5,1.5h7 c0.83,0,1.5-0.67,1.5-1.5V1.5C18,0.67,17.33,0,16.5,0L16.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.47,13.64L7.72,13.63c-0.14,0-0.25-0.11-0.25-0.25l0-1.18c0-0.14,0.11-0.25,0.25-0.25l10.75,0.01 c0.14,0,0.25,0.11,0.25,0.25l0,1.18C18.72,13.52,18.61,13.64,18.47,13.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.47,17.88L7.72,17.87c-0.14,0-0.25-0.11-0.25-0.25l0-1.18c0-0.14,0.11-0.25,0.25-0.25l10.75,0.01 c0.14,0,0.25,0.11,0.25,0.25l0,1.18C18.72,17.77,18.61,17.88,18.47,17.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.47,22.13L7.72,22.12c-0.14,0-0.25-0.11-0.25-0.25l0-1.18c0-0.14,0.11-0.25,0.25-0.25l10.75,0.01 c0.14,0,0.25,0.11,0.25,0.25l0,1.18C18.72,22.01,18.61,22.13,18.47,22.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.47,9.39L7.72,9.38c-0.14,0-0.25-0.11-0.25-0.25l0-1.18c0-0.14,0.11-0.25,0.25-0.25l10.75,0.01 c0.14,0,0.25,0.11,0.25,0.25l0,1.18C18.72,9.28,18.61,9.39,18.47,9.39z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/Summary.e049930d98480f7b56564bea730b4b70.svg";
export { ForwardRef as ReactComponent };